import React, { useEffect } from 'react'
import '../../../../assets-static/cortec-iframe/iframeResizer.min.js'
import Scroll from 'react-scroll'
import config from '../config.json'

const scroller = Scroll.scroller


const CortecIframe = ({showId, routesData, scrollToPosition}) => {
    
    // const isMobile = () => {
    //     const width = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/"/g, '')
        
    //     return width < config.breakpoints.slidebarRight
    // }
    
    // const scrollIframeIntoView = (isMobile, iframe) => {
    //     if(isMobile) {
    //         iframe.scrollIntoView({
    //             behavior: 'smooth'
    //         })
    //     } else {
    //         scroller.scrollTo(scrollToPosition + ' performance-iframe', {
    //             smooth: true,
    //             offset: -200,
    //             isDynamic: true
    //         })
    //     }
    // }
    
    
    // const onScrollPositionAdvice = args => {
    //     const iframe = document.getElementById('cortec-iframe')
    //     const header = document.getElementById('site-header')    
    //     const mobile = isMobile()
        
    //     const iFrameBounding = iframe.getBoundingClientRect()
    //     const headerBounding = header.getBoundingClientRect()
        
    //     if(mobile || iFrameBounding.top < headerBounding.height + 20) {
    //         scrollIframeIntoView(mobile, iframe)
    //     }
    // }
    // Function to handle messages received from the iframe
    const receiveMessage = (event) => {
        // onScrollPositionAdvice()
        // Check if the message comes from the expected iframe origin
        // Replace 'booking.cinemaforum.ch' with the actual iframe origin
        const expectedOrigin = 'booking.kinomadlen.ch';
        if (event.origin !== expectedOrigin) {
            console.log('Unexpected message origin:', event.origin);
            return;
        }

    
        // Check if the message requests scrolling to the top
        if (event.data === 'scrollToTop') {
            // onScrollPositionAdvice()
        }
    }
    
    useEffect(() => {
        setTimeout(iFrameResize([{log: false,checkOrigin: false,autoResize: true,heightCalculationMethod:"min"}], '#cortec-iframe-frame'), 1000) 

        // Listen for messages from the iframe
        window.addEventListener('message', receiveMessage)
        
    
        return () => {
            window.removeEventListener('message', receiveMessage);
        }
    })

    return (
        <div id="cortec-iframe" className='theme-radius-posters-full'>
            <iframe id="cortec-iframe-frame" src={`https://booking.kinomadlen.ch/clients_bootstrap/eventBookingGlobal/booking_wizard.asp?eventID=${showId}`}/>
        </div>
    )  
}

export default CortecIframe